import "./Copyrights.css";

export default function Copyrights() {
  const currentYear = new Date().getFullYear();
  return <div className="copy-rights">© {currentYear} Kwality Wall’s India Limited</div>;
}
